@if (!useSummaryView) {
    @if (!field.hidden) {
        <div animate.enter="fade-in" class="flex flex-col w-full justify-between">
            <div class="flex flex-row items-center w-full">
                @if (field.browserOpts.inLineWithCaption) {
                    <mat-label class="mr-2 mb-4 font-medium">
                        {{ field.label | localize }}
                    </mat-label>
                }
                <mat-form-field class="w-full">
                    @if (!field.browserOpts.inLineWithCaption) {
                        <mat-label>{{ field.label | localize }}</mat-label>
                    }
                    <input matInput type="text" [formControl]="controlOriginal" [placeholder]="'convertTime' | transloco"
                        [readonly]="field.readonly" [required]="field.required">
                    @if (!field.hint) {
                        <mat-hint>{{ 'infoFormat' | transloco }}</mat-hint>
                    } @else {
                        <mat-hint>{{ field.hint | localize }}</mat-hint>
                    }
                    @if (controlOriginal.hasError('pattern') && !field.readonly) {
                        <mat-error>
                            {{ 'errorInFormat' | transloco }}
                        </mat-error>
                    } @else if (field.control.hasError('required') && !field.readonly) {
                        <mat-error>
                            {{ 'errorRequiredField' | transloco }}
                        </mat-error>
                    }
                </mat-form-field>
            </div>
        </div>
    }
} @else {
    {{ defaultValue }}
}